import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { afterNextRender, Directive, ElementRef, inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';

@Directive({
    selector: '[forceTargetBlank]',
    standalone: true
})
export class ForceTargetBlankDirective implements OnDestroy {
    links: HTMLLinkElement[] = [];

    protected window = inject(DOCUMENT).defaultView as Window;
    protected readonly isPlatformBrowser = isPlatformBrowser(inject(PLATFORM_ID));

    constructor(
        protected elementRef: ElementRef,
        protected timeoutService: TimeoutService
    ) {
        afterNextRender(() => {
            this.links = this.elementRef.nativeElement.querySelectorAll('a');

            this.links?.forEach(link => this.addTargetBlankListeners(link));
        });
    }

    ngOnDestroy() {
        this.links?.forEach(link => this.removeTargetBlankListeners(link));
    }

    private forceTargetBlankHandler = (event: MouseEvent, link: HTMLLinkElement) => {
        event.preventDefault();

        if (this.isPlatformBrowser) {
            this.window.open(link.href, '_blank');
        }
    };

    private addTargetBlankListeners(link: HTMLLinkElement) {
        if (link.hasAttribute('target') && link.getAttribute('target').match(/_blank/i)) {
            link.addEventListener('click', event => this.forceTargetBlankHandler(event, link));
        }
    }

    private removeTargetBlankListeners(link: HTMLLinkElement) {
        if (link.hasAttribute('target') && link.getAttribute('target').match(/_blank/i)) {
            link.removeEventListener('click', event => this.forceTargetBlankHandler(event, link));
        }
    }
}
